'use strict';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// Deprecated in favor of GoogleSigninButton
var GoogleLoginOrSignup = _react2['default'].createClass({
    displayName: 'GoogleLoginOrSignup',


    propTypes: {
        'openIdUrl': _react2['default'].PropTypes.string.isRequired,
        'isLogIn': _react2['default'].PropTypes.bool,
        'isOptedIn': _react2['default'].PropTypes.bool
    },

    onClickHandler: function onClickHandler() {
        var url = this.props.openIdUrl + '&optIn=' + (this.props.isOptedIn ? '1' : '0');
        var w = window.open(url, '_blank', 'width=640, height=480');
        window.hsGoogleOpenIdWindow = w;
    },
    render: function render() {
        var classSet = (0, _classnames2['default'])({
            'm-google-button': true,
            'm-button': true
        });
        return _react2['default'].createElement(
            'a',
            { className: classSet, onClick: this.onClickHandler },
            _react2['default'].createElement('i', null),
            _react2['default'].createElement(
                'span',
                null,
                this.props.isLogIn ? 'Sign in with Google' : 'Sign up with Google'
            )
        );
    }
});

module.exports = GoogleLoginOrSignup;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/auth/google-login-or-signup.jsx
 ** module id = 874
 ** module chunks = 0
 **/